import { FEDERAL_STATES } from '../../data/holidays-de';
import type { FederalState } from '../../domain/holidays';
import { compareText } from '../i18n/format';
import { MESSAGES, type Language } from '../i18n/messages';
import { BackupError } from '../state/backup';

/**
 * DE: Bundesländer zur Auswahl, nach ihrem Namen in der Sprache sortiert.
 * EN: Federal states to choose from, sorted by their name in the language.
 */
export function stateOptions(language: Language): { id: FederalState; name: string }[] {
  const names = MESSAGES[language].states;
  return FEDERAL_STATES.map((id) => ({ id, name: names[id] })).sort((a, b) =>
    compareText(a.name, b.name, language),
  );
}

/**
 * DE: Grund, warum eine Sicherung nicht passt; unbekannte Fehler gelten als unlesbare Datei.
 * EN: Reason why a backup does not fit; unknown errors count as an unreadable file.
 */
export function backupErrorCode(error: unknown): BackupError['code'] {
  return error instanceof BackupError ? error.code : 'invalid';
}
